import { useContext } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import InputActions from "../InputActions/InputActions";
import SimpleListTable from "../../../ListTable/ListTable";

const ListTableInput = ({ item, onStartEdit, onDuplicate, onDelete }) => {
   const { previewMode } = useContext(FormBuilderContext);

   return (
      <>
         <label className="form-builder-input-label">{item.label}:</label>

         <div className="form-builder-input">
            <div onClick={onStartEdit}>
               <SimpleListTable
                  listId={item.modelField.list.listId}
                  defaultFilterId={item.modelField.list.defaultFilterId}
               />
            </div>
            <div className="list-action-buttons">
               {!previewMode && (
                  <InputActions
                     onStartEdit={onStartEdit}
                     onDuplicate={onDuplicate}
                     onDelete={onDelete}
                  />
               )}
            </div>
         </div>
      </>
   );
};

export default ListTableInput;
